export default function(x) {
  return function() {
    return x;
  };
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-voronoi/src/constant.js
// module id = ./node_modules/d3-voronoi/src/constant.js
// module chunks = 53